import React from 'react'
import PropTypes from 'prop-types'
import { useCallback, useMemo, useState } from 'sb-hooks'
import Measure from 'react-measure'
import cx from 'classnames'

import s from './Collapsible.scss'


const Collapsible = (props) => {
  const { children, className, contentClassName, collapsed, withMeasure } = props

  const [ height, setHeight ] = useState(null)

  const handleResize = useCallback(({ bounds }) => {
    setHeight(bounds.height)
  }, [])

  const rootClassName = cx(s.collapsible, className)

  const style = useMemo(
    () => ({ height: collapsed ? 0 : (height || 'auto') }),
    [ height, collapsed ]
  )

  return (
    <div className={rootClassName} style={style}>
      {
        withMeasure ? (
          <Measure onResize={handleResize} bounds>
            {
              ({ measureRef }) => (
                <div ref={measureRef} className={contentClassName}>
                  {children}
                </div>
              )
            }
          </Measure>
        ) : (
          <div className={contentClassName}>
            {children}
          </div>
        )
      }
    </div>
  )
}

Collapsible.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  collapsed: PropTypes.bool.isRequired,
  withMeasure: PropTypes.bool,
}

Collapsible.defaultProps = {
  withMeasure: true,
}


export default Collapsible
